import { MouseEvent } from 'react'

import getColor from '~/lib/getColor'

const BUTTON_STYLE = {
    background: 'white',
    border: `1px solid ${getColor('grey5')}`,
    borderRadius: '4px',
    cursor: 'pointer',
    padding: '0 8px 2px 8px',
}

const TEXT_STYLE = {
    color: getColor('blackAlpha45'),
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '20px',
}

const ICON_STYLE = {
    color: getColor('blackAlpha45'),
    marginRight: '10px',
}

interface PropsType {
    onClick?: (event: MouseEvent<HTMLButtonElement>) => void
}

// This component does not use the core/Box, core/Text, or antd Icon
// because it is not compatible with the PDFTron integration
// Using our core or antd components breaks the page when
// it is inserted into the PDFViewer
const BackTo3DModelButtonComponent = (props: PropsType) => {
    const { onClick } = props

    return (
        <button onClick={onClick} style={BUTTON_STYLE}>
            <svg
                width="14"
                height="14"
                viewBox="0 0 24 17"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={ICON_STYLE}
            >
                <path
                    d="M20.4366 11.1095H6.72331L14.9311 3.9845C15.0624 3.86965 14.9827 3.65637 14.8092 3.65637H12.735C12.6436 3.65637 12.5569 3.68918 12.4889 3.74778L3.6319 11.4329C3.55078 11.5033 3.48573 11.5902 3.44114 11.6878C3.39655 11.7855 3.37347 11.8916 3.37347 11.999C3.37347 12.1063 3.39655 12.2124 3.44114 12.3101C3.48573 12.4077 3.55078 12.4946 3.6319 12.565L12.5405 20.297C12.5757 20.3275 12.6178 20.3439 12.6624 20.3439H14.8069C14.9803 20.3439 15.06 20.1282 14.9288 20.0157L6.72331 12.8907H20.4366C20.5397 12.8907 20.6241 12.8064 20.6241 12.7032V11.297C20.6241 11.1939 20.5397 11.1095 20.4366 11.1095Z"
                    fill="black"
                    fillOpacity="0.65"
                />
            </svg>
            <span style={TEXT_STYLE}>Back to 3D model</span>
        </button>
    )
}

const BackTo3DModelButton = (props: PropsType) => {
    const { onClick } = props

    return {
        type: 'customElement',
        render: () => <BackTo3DModelButtonComponent onClick={onClick} />,
    }
}

export default BackTo3DModelButton
export { BackTo3DModelButtonComponent }
